import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import { Chip, Typography, ClickAwayListener } from '@material-ui/core';

const DetailedChip = ({
  option,
  classes,
  label,
  isTextMessage,
  shouldNavigateToClientProfile,
  onClickChip,
  isAutoPopulateDefaultEmailEnabled,
  ...props
}) => {
  const [isChipDetailed, setIsChipDetailed] = useState(false);
  const history = useHistory();

  const toggleDetailedView = (event) => {
    event.stopPropagation();
    if (shouldNavigateToClientProfile && option.profileId) {
      history.push(`/clients/universal-profile/${option.profileId}`);
      return;
    }
    if (isAutoPopulateDefaultEmailEnabled) {
      onClickChip(option);
    } else {
      setIsChipDetailed(!isChipDetailed);
    }
  };

  const handleClickAway = () => {
    setIsChipDetailed(false);
  };

  const detailedChip = (
    <div role="button" className={classes.detailedChip}>
      <div>
        <Typography variant="body1" component="span">
          {option.fullName}
        </Typography>
        <br />
        <Typography variant="body2" component="span">
          {option.contact}
        </Typography>
      </div>
      <Typography component="span" variant="body1" className={classes.closeIcon}>
        <CloseIcon />
      </Typography>
    </div>
  );
  const textMessageChip = (
    <div role="button" className={classes.detailedTextChip}>
      <div>
        <Typography variant="body1" component="span">
          {option.fullName}
        </Typography>
        <br />
        <Typography variant="body2" component="span">
          {option.contact}
        </Typography>
      </div>
      <Typography component="span" variant="body1" className={classes.closeTextIcon}>
        <CloseIcon />
      </Typography>
    </div>
  );
  const style =
    isTextMessage && isChipDetailed
      ? {
          position: 'relative',
          background: '#00857C',
          border: 'none',
          height: 60,
          width: 'auto',
          color: 'white',
        }
      : {
          position: 'relative',
          background: '#0000000D',
          border: 'none',
          height: 30,
        };
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Chip
        data-testid="chip"
        {...props}
        onClick={toggleDetailedView}
        style={style}
        label={
          isChipDetailed ? (
            <div>
              {label}
              {isTextMessage ? textMessageChip : detailedChip}
            </div>
          ) : (
            label
          )
        }
      />
    </ClickAwayListener>
  );
};

DetailedChip.propTypes = {
  classes: PropTypes.shape({}),
  option: PropTypes.shape({}),
  label: PropTypes.string,
  isTextMessage: PropTypes.bool,
  shouldNavigateToClientProfile: PropTypes.bool,
  onClickChip: PropTypes.func,
  isAutoPopulateDefaultEmailEnabled: PropTypes.bool,
};

DetailedChip.defaultProps = {
  classes: {},
  option: {},
  label: '',
  isTextMessage: false,
  shouldNavigateToClientProfile: false,
  onClickChip: () => {},
  isAutoPopulateDefaultEmailEnabled: false,
};

export default DetailedChip;
